import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

import { TextInput } from 'reactGarden/Input'

const COLOR_MAP = {
  success: 'p500',
  danger: 'r500',
  loading: 'n200'
}

const postalCodeStyles = ({ theme }) => css`
  label: postal-code;

  display: flex;
  align-items: flex-start;
  flex-direction: column;

  position: relative;

  border: 1px solid ${theme.colors.p100};
  border-radius: ${theme.borderRadius.giga};

  margin-top: ${theme.spacings.giga};
  padding: ${theme.spacings.mega};

  width: 100%;

  & > svg {
    label: postal-code__icon;

    position: absolute;
    top: 58px;
    right: ${theme.spacings.tera};
  }
`

const statusStyles = ({ theme, status }) => {
  const currentColor = status ? COLOR_MAP[status] : 'n200'

  return css`
    & ${Input} {
      label: postal-code__input--${status};

      border-color: ${theme.colors[currentColor]};
    }
  `
}

const dangerStyles = ({ theme, status }) =>
  status === 'danger' &&
  css`
    & > svg {
      label: postal-code__icon--${status};

      color: ${theme.colors.r600};
    }
  `

export const PostalCode = styled('div')(postalCodeStyles, statusStyles, dangerStyles)

const labelStyles = ({ theme }) => css`
  label: postal-code__label;

  color: ${theme.colors.n800};

  font-size: ${theme.typography.text.kilo.fontSize};
  font-weight: ${theme.font.weight.semibold};

  margin-left: ${theme.spacings.mega};
`

export const Label = styled('label')(labelStyles)

const inputStyles = ({ theme }) => css`
  label: postal-code__input;

  padding: ${theme.spacings.kilo} ${theme.spacings.mega};

  &:disabled {
    label: postal-code__input--disabled;

    background-color: ${theme.colors.n100};
    border-color: ${theme.colors.n100};
  }
`

export const Input = styled(TextInput)(inputStyles)

const linkStyles = ({ theme, isDisabled }) => css`
  label: postal-code__link;

  color: ${isDisabled ? theme.colors.n300 : theme.colors.p500};
  font-size: ${theme.typography.text.kilo.fontSize};
  margin-left: ${theme.spacings.mega};
`

export const Link = styled('a')(linkStyles)

const separatorStyles = ({ theme }) => css`
  label: postal-code__separator;

  background-color: ${theme.colors.p100};
  margin: ${theme.spacings.kilo} 0;
`

export const Separator = styled('hr')(separatorStyles)

const informativeMessageStyles = ({ theme, isDisabled }) => css`
  label: postal-code__informative-message;

  color: ${isDisabled ? theme.colors.n500 : theme.colors.n900};
`

export const InformativeMessage = styled(Text)(informativeMessageStyles)
